import { Alert } from "../components/Alert";
import { ShowLoading, HideLoading } from "../components/Loading";

export default class Util {
    static hideLoading = () => {
        HideLoading();
    };

    static showLoading = () => {
        ShowLoading();
    };

    static showDialog = ({ title = '', message = '', buttons = [{ text: 'OK' }] }) => {
        Alert({ title: title, message: message, buttons: buttons });
    };

    static getMerchantInfo = (agreement) => {
        var bindingdata = agreement.opts ? agreement : agreement.binding_data;
        var merchant_name = agreement.merchant_name;
        var app_icon_url = agreement.app_icon_url;

        if (bindingdata) {
            if (bindingdata.opts !== "") {
                var opts = JSON.parse(bindingdata.opts);
                if (opts) {
                    if (opts.app_name) {
                        merchant_name = opts.app_name;
                    }
                    if (opts.app_logo_url) {
                        app_icon_url = opts.app_logo_url;
                    }
                };
            }
        }

        if (!merchant_name || merchant_name === "") {
            merchant_name = "";
        }
        if (app_icon_url)
            app_icon_url = app_icon_url.replace("http://", "https://");
        return { merchant_name, app_icon_url }
    }

    static getBrowserName = () => {
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        var fullVersion = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;

        // In Opera 15+, the true version is after "OPR/"
        if ((verOffset = nAgt.indexOf("OPR/")) != -1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset + 4);
        }
        // In older Opera, the true version is after "Opera" or after "Version"
        else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browserName = "IE";
            fullVersion = nAgt.substring(verOffset + 5);
        }
        // In Chrome, the true version is after "Chrome"
        else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
            fullVersion = nAgt.substring(verOffset + 7);
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browserName = "Safari";
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf("Version")) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        // In Firefox, the true version is after "Firefox"
        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browserName = "Firefox";
            fullVersion = nAgt.substring(verOffset + 8);
        }
        // In most other browsers, "name/version" is at the end of userAgent
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
            (verOffset = nAgt.lastIndexOf('/'))) {
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() == browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }

        return browserName;
    }

    static getMobileOS = () => {
        const ua = navigator.userAgent
        if (/android/i.test(ua)) {
          return "Android"
        }
        else if((/iPad|iPhone|iPod/.test(ua))
           || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)){
          return "iOS"
        }
        return "Other"
    }

    static getCustomMerchantName = (bindingInfo) => {
        let name = bindingInfo?.merchant?.name ?? '';
        try {
            if (bindingInfo?.merchant?.data) {
                if (bindingInfo.merchant.data.opts) {
                    let opts = JSON.parse(bindingInfo.merchant.data.opts);
                    name = opts.app_name;
                }else {
                    let customData = JSON.parse(bindingInfo.merchant.data);
                    if (customData?.opts?.app_name) {
                        name = customData.opts.app_name;
                    }else if (customData?.opts) {
                        let optsData = JSON.parse(customData.opts)
                        name = optsData?.app_name;
                    }
                }
            }
        }catch (e) {
            console.log('GetCustomName err: ', e)
        }
        return name
    };

}

function injectScriptSheet(name, url) {
	// eslint-disable-next-line consistent-return
	return new Promise((resolve, reject) => {
		if (name === null || name === undefined) return resolve();
		const head = document.head || document.getElementsByTagName('head')[0];
		const id = ''.concat(name.toUpperCase(), '_SCRIPT');
		if (document.getElementById(id)) return resolve();
		const script = document.createElement('script');
		script.id = id;
		script.type = 'text/javascript';
		script.src = url;
		script.onload = resolve;
		script.onerror = reject;
		head.appendChild(script);
	});
}

export async function injectDebugger() {
	await injectScriptSheet('ERUDA_DEBUGGER', 'https://cdn.jsdelivr.net/npm/eruda');
	window.eruda.init();
}

export const getRandomArbitrary = (min, max) => {
    return Math.random() * (max - min) + min;
}

export const wait = async (delay) => {
    return new Promise((resolve) => setTimeout(resolve, delay));
}

export const GetStaticMc = (path) => {
    return `https://scdn.zalopay.com.vn/data/agp/authorize-fe/${path}`
}

